import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorage } from './local-storage';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private _currentLanguage = new BehaviorSubject<string>(this.translate.currentLang || this.translate.defaultLang);

  public readonly currentLanguage$: Observable<string> = this._currentLanguage.asObservable();

  constructor(private translate: TranslateService, private localStorage: LocalStorage) {

    this.translate.onLangChange.subscribe(event => {
      this._currentLanguage.next(event.lang);
      localStorage.set('language', event.lang);
    });


    const savedLanguage = localStorage.get('language');
    if (savedLanguage && savedLanguage !== this.translate.currentLang) {
      this.setLanguage(savedLanguage);
    } else if (!this.translate.currentLang) {
      this.setLanguage(this.translate.defaultLang);
    }
  }


  getCurrentLanguage(): string {
    return this._currentLanguage.getValue();
  }

  /**
   * Sets the application language. This method is the primary way to change
   * the language from any component. It delegates to ngx-translate.
   * @param lang 
   */
  setLanguage(lang: string): void {
    if (this._currentLanguage.getValue() !== lang) {
      this.translate.use(lang).subscribe(() => {
      }, error => {
      });
    }
  }
}